import React from "react";

const AppSmallLogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="app_small_logo_icon"
      data-name="small_logo"
      {...props}
      width={props.width || "36"}
      height={props.height || "40"}
      viewBox="0 0 36 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4675_30227)">
        <path
          d="M11.8271 38.3487C11.8271 38.3487 10.9322 40.2075 8.52265 40.2075C6.11313 40.2075 5.42467 38.0734 5.42467 38.0734L1.44201 26.9033C0.487753 24.227 0 21.4068 0 18.5654V4.87597C0 1.38216 2.32921 0.27832 4.65842 0.27832H23.6248C26.4531 0.27832 27.9504 2.38039 27.9504 4.70959V7.87065H31.777C32.4425 7.87065 33.3633 7.98567 34.4389 9.03525C35.5412 10.1108 35.647 11.8636 35.647 11.8636V19.5425C35.647 22.5097 35.1149 25.4527 34.0777 28.2327C32.9227 31.3284 31.3899 35.4408 30.4148 38.0734C30.4148 38.0734 29.3822 40.2075 27.2481 40.2075C25.0408 40.2075 24.2878 38.6241 24.2878 38.6241L20.6391 28.5041C20.6391 28.5041 19.7441 26.783 18.043 26.783C15.8201 26.783 15.1316 28.5041 15.1316 28.5041L11.8271 38.3487Z"
          fill="#5BB2DF"
        />
        <mask
          id="mask0_4675_30227"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="41"
        >
          <path
            d="M11.8271 38.3488C11.8271 38.3488 10.9322 40.2075 8.52265 40.2075C6.11313 40.2075 5.42467 38.0734 5.42467 38.0734L1.11813 25.995C0.378204 23.9197 1.94225e-06 21.7387 0 19.5355V14.2549C0 6.53658 6.25692 0.27832 13.9752 0.27832H24.1544C26.2509 0.27832 27.9504 1.97787 27.9504 4.07437C27.9504 6.16448 29.64 7.86137 31.7301 7.87039L31.7904 7.87065C33.9203 7.87065 35.647 9.5965 35.647 11.7264V21.5457C35.647 23.1904 35.3503 24.8174 34.7725 26.3573C33.6167 29.4381 31.5899 34.8543 30.4148 38.0734C30.4148 38.0734 29.3822 40.2075 27.2481 40.2075C25.0408 40.2075 24.2878 38.6241 24.2878 38.6241L20.6391 28.5041C20.6391 28.5041 19.7441 26.783 18.043 26.783C15.8201 26.783 15.1316 28.5041 15.1316 28.5041L11.8271 38.3488Z"
            fill="#5BB2DF"
          />
        </mask>
        <g mask="url(#mask0_4675_30227)">
          <path
            d="M10.3143 7.85099H31.2771C31.2771 7.85099 33.504 7.72417 34.6046 9.03517C35.5285 10.1358 35.6603 11.5307 35.6603 11.5307V40.2074H6.19531V12.1962C6.19531 11.0316 6.32138 7.85099 10.3143 7.85099Z"
            fill="#3386B8"
          />
          <path
            d="M27.9492 7.85091H31.2765C31.2765 7.85091 33.4393 7.7629 34.6039 9.03507C35.662 10.1909 35.6597 11.8634 35.6597 11.8634V40.2073H27.9492V7.85091Z"
            fill="#4E92C1"
          />
          <path
            d="M13.143 16.8552C14.1794 15.6604 16.304 15.8374 16.304 15.8374H35.6607V40.208H12.2539V19.3507C12.2539 19.3507 12.2439 17.8916 13.143 16.8552Z"
            fill="#347AAD"
          />
          <path
            d="M13.3097 16.8544C14.4228 15.7308 16.3043 15.8366 16.3043 15.8366H28.0882C28.0882 15.8366 28.2768 22.6561 27.2849 26.0049C25.9019 30.6736 20.1024 34.3555 20.1024 34.3555L12.2542 40.2072V19.8491C12.2542 19.8491 12.2068 17.9676 13.3097 16.8544Z"
            fill="#1B6B9E"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4675_30227">
          <rect width="36" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AppSmallLogoIcon;
